import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { ShieldCheck, Music, AlertCircle } from 'lucide-react';

const LoginModal = ({ onLoginSuccess }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/60 backdrop-blur-sm px-4">
      <div className="bg-white rounded-[32px] shadow-2xl w-full max-w-md overflow-hidden animate-slide-up">
        {/* Header Decor */}
        <div className="h-2 bg-blue-600 w-full" />
        
        <div className="p-10 flex flex-col items-center text-center">
          {/* Logo/Icon */}
          <div className="w-20 h-20 bg-blue-50 rounded-3xl flex items-center justify-center text-blue-600 mb-6 shadow-sm border border-blue-100">
            <ShieldCheck size={40} strokeWidth={2.5} />
          </div>

          <h2 className="text-3xl font-black text-gray-900 mb-2 tracking-tight">
            Admin Access
          </h2>
          <p className="text-gray-500 font-medium mb-8">
            Please sign in with your authorized Bethany Music Gmail account to continue.
          </p>

          {/* Google Login */}
          <div className="w-full flex flex-col gap-4 mb-8">
            <div className="flex justify-center py-4 bg-gray-50 rounded-2xl border border-gray-100">
              <GoogleLogin
                onSuccess={(credentialResponse) => {
                  localStorage.setItem('admin_token', credentialResponse.credential);
                  onLoginSuccess(credentialResponse.credential);
                }}
                onError={() => {
                  console.log('Login Failed');
                }}
                useOneTap
                theme="filled_blue"
                shape="pill"
              />
            </div>
          </div>

          {/* Info/Warning Footer */}
          <div className="flex items-start space-x-3 text-left p-4 bg-orange-50 rounded-2xl border border-orange-100 w-full">
            <AlertCircle size={20} className="text-orange-500 shrink-0 mt-0.5" />
            <p className="text-xs text-orange-700 font-medium leading-relaxed">
              Only whitelisted administrators can access this portal.
            </p>
          </div>
          
          <div className="mt-8 flex items-center space-x-2 text-gray-400">
            <Music size={14} />
            <span className="text-[10px] font-bold uppercase tracking-widest">bChoir Intelligence Platform</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
